import React, { PureComponent } from 'react';
import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

class CircleProgressBar extends PureComponent {
  render() {
    const { percentage, endColor, startColor, gradientId } = this.props;
    const gradientTransform = `rotate(90)`;
    return (
      <div className="progress-bar">
        <svg style={{ height: 0, width: 0 }}>
          <defs>
            <linearGradient
              id={gradientId}
              gradientTransform={gradientTransform}
            >
              <stop offset="0%" stopColor={startColor} />
              <stop offset="100%" stopColor={endColor} />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgressbar
          percentage={percentage}
          text={`${percentage}`}
          strokeWidth="15"
          styles={{
            path: { stroke: `url(#${gradientId})`, height: '100%' },
            text: {
              fontSize: '28px',
              fill: percentage !== 0 ? endColor : '#dddddd',
              fontWeight: 'bold'
            }
          }}
        />
      </div>
    );
  }
}

export default CircleProgressBar;
